import { indexOf, shuffle, intersection } from 'lodash';

export const getSelectedFrontImageId = state => state.selectedFrontImage;
export const getSelectedBackImageId = state => state.selectedBackImage;
export const getFrontImagesOrder = state => state.frontImagesOrder;
export const getBackImagesOrder = state => state.backImagesOrder;
export const getMatchedImageIds = state => state.matchedImages || [];

export const getFamilyMember = (state, id) => state.byIds[id] || {};
export const getFamilyMembers = (state, ids = []) => ids.map(id => getFamilyMember(state, id));

export const get5RandomFamilyMembersToMatch = state => {

    const fiveRandomCardsWithoutRozina = shuffle(state.allIds)
        .filter(id => (
            indexOf(getMatchedImageIds(state), id) === -1) &&
            (id !== 'patkai_rozina')
        )
        .slice(0, 5);

    const matchedImageIds = getMatchedImageIds(state);

    return matchedImageIds.length < state.allIds.length - 5
        ? fiveRandomCardsWithoutRozina
        : [...fiveRandomCardsWithoutRozina, 'patkai_rozina'];
}

export const getFrontImages = state => {
    const frontImagesOrder = getFrontImagesOrder(state);
    return getFamilyMembers(state, frontImagesOrder);
};
export const getBackImages = state => {
    const backImagesOrder = getBackImagesOrder(state);
    return getFamilyMembers(state, backImagesOrder);
};

export const isFrontImageSelected = (state, id) => getSelectedFrontImageId(state) === id;
export const isBackImageSelected = (state, id) => getSelectedBackImageId(state) === id;

const getMatchedImages = state => getFamilyMembers(state, getMatchedImageIds(state));
export const getMatchedSurvivors = state => getMatchedImages(state).filter(image => image.isSurvivor);
export const getMatchedVictims = state => getMatchedImages(state).filter(image => !image.isSurvivor);

export const showLargeImages = state => {
    const frontImageId = getSelectedFrontImageId(state);
    const backImageId = getSelectedBackImageId(state);

    return frontImageId && backImageId && (frontImageId === backImageId);
}

export const areAllImagesMatched = state => {
    return getMatchedImageIds(state).length === state.allIds.length
}

export const isInitState = state => {
    const frontImagesOrderIds = getFrontImagesOrder(state);
    const backImagesOrderIds = getBackImagesOrder(state);
    const matchedImageIds = getMatchedImageIds(state);

    return frontImagesOrderIds.length === 0 &&
        backImagesOrderIds.length === 0 &&
        matchedImageIds.length === 0;
}

export const areAllActCardsMatched = state => {
    const frontImageIds = getFrontImagesOrder(state);
    const matchedImageIds = getMatchedImageIds(state);

    return intersection(frontImageIds, matchedImageIds).length === frontImageIds.length;
}

export const isSelectionActive = state => getSelectedFrontImageId(state) || getSelectedBackImageId(state);

export const isFinalSceneActive = state => state.isFinalSceneActive;
